import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const DefaultLayout = () => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <Navbar />
            <Box sx={{ flex: 1, pt: { xs: '72px', md: '104px' } }}>
                <Outlet />
            </Box>
            <Footer />
        </Box>
    );
};

export default DefaultLayout; 